import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axioKit } from "../../../../utilities";

const url = "assets/persons/users";

const initialState = {
  collections: [],
  formSubmitted: false,
  filtered: [],
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const BROWSE = createAsyncThunk(`${url}`, ({ key, token }, thunkAPI) => {
  try {
    return axioKit.universal(`${url}/browse`, token, key);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();

    return thunkAPI.rejectWithValue(message);
  }
});

export const GETPATIENTS = createAsyncThunk(
  `${url}/patients`,
  ({ token, key }, thunkAPI) => {
    try {
      return axioKit.universal(`${url}/patients`, token, key);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SAVE = createAsyncThunk(`${url}/save`, (form, thunkAPI) => {
  try {
    console.log("form", form);
    return axioKit.save(url, form.data, form.token);
  } catch (error) {
    const message =
      (error?.response &&
        error.response?.data &&
        error.response?.data?.message) ||
      error.message ||
      error.toString();

    return thunkAPI.rejectWithValue(message);
  }
});

export const REGISTER = createAsyncThunk(
  `${url}/register`,
  ({ data }, thunkAPI) => {
    try {
      // /register checks the emailed code; /save is for staff and needs a login.
      return axioKit.save(url, data, "", "register");
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DUPLICATE_CHECKER = createAsyncThunk(
  `${url}/duplicate_checker`,
  ({ data }, thunkAPI) => {
    try {
      return axioKit.save(url, data, "", "duplicate_checker");
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.message) ||
        error?.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const UPDATE = createAsyncThunk(`${url}/update`, (form, thunkAPI) => {
  try {
    return axioKit.update(url, form.data, form.token);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();

    return thunkAPI.rejectWithValue(message);
  }
});
export const RESET_PASSWORD = createAsyncThunk(
  `${url}/reset_password`,
  (form, thunkAPI) => {
    try {
      return axioKit.update(url, form.data, form.token, "reset_password");
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const VALIDATE_ID = createAsyncThunk(
  `${url}/validate_ID`,
  (form, thunkAPI) => {
    try {
      return axioKit.update(url, form.data, form.token, "validate_ID");
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const reduxSlice = createSlice({
  name: url,
  initialState,
  reducers: {
    SetCOLLECTIONS: (state, { payload }) => {
      state.collections = payload;
    },
    CUSTOMALERT: (state, data) => {
      state.message = data.payload;
    },
    RESET: (state) => {
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(BROWSE.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(BROWSE.fulfilled, (state, { payload, success }) => {
        state.collections = payload.payload;
        // state.collectionsUsers = payload;
        state.isLoading = false;
        state.message = success;
      })
      .addCase(BROWSE.rejected, (state, action) => {
        const { error } = action;
        state.message = error.message;
        state.isLoading = false;
      })

      .addCase(GETPATIENTS.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(GETPATIENTS.fulfilled, (state, action) => {
        const { payload } = action.payload;
        state.filtered = payload;
        state.collections = payload;
        state.isLoading = false;
      })
      .addCase(GETPATIENTS.rejected, (state, action) => {
        const { error } = action;
        state.message = error.message;
        state.isLoading = false;
      })

      .addCase(SAVE.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(SAVE.fulfilled, (state, action) => {
        const { success, payload } = action.payload;
        state.message = success;
        state.collections.unshift(payload);
        state.isSuccess = true;
        state.isLoading = false;
      })
      .addCase(SAVE.rejected, (state, action) => {
        const { error } = action;
        state.message = error.message;
        state.isLoading = false;
      })

      .addCase(UPDATE.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(UPDATE.fulfilled, (state, action) => {
        const { success, payload } = action?.payload;
        const index = state.collections.findIndex(
          (item) => item?._id === payload?._id
        );

        state.collections[index] = payload;
        state.message = success;
        state.isSuccess = true;
        state.isLoading = false;
      })
      .addCase(UPDATE.rejected, (state, action) => {
        const { error } = action;
        state.message = error;
        state.isLoading = false;
      })

      .addCase(RESET_PASSWORD.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(RESET_PASSWORD.fulfilled, (state, action) => {
        const { success, payload } = action?.payload;
        const index = state.collections.findIndex(
          (item) => item?._id === payload?._id
        );
        state.collections.splice(index, 1);
        state.message = success;
        state.isSuccess = true;
        state.isLoading = false;
      })
      .addCase(RESET_PASSWORD.rejected, (state, action) => {
        const { error } = action;
        state.message = error;
        state.isLoading = false;
      })

      .addCase(VALIDATE_ID.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(VALIDATE_ID.fulfilled, (state, action) => {
        const { success } = action.payload;
        state.message = success;
        state.isSuccess = true;
        state.isLoading = false;
      })
      .addCase(VALIDATE_ID.rejected, (state, action) => {
        const { error } = action;
        state.message = error.message;
        state.isLoading = false;
      })
      .addCase(DUPLICATE_CHECKER.pending, (state) => {
        state.formSubmitted = true;
        state.message = "";
      })
      .addCase(DUPLICATE_CHECKER.fulfilled, (state, action) => {
        const { success } = action;
        state.message = success;
        state.formSubmitted = false;
      })
      .addCase(DUPLICATE_CHECKER.rejected, (state, action) => {
        state.message =
          action.payload || action.error?.message || "Something went wrong";
        state.formSubmitted = false;
      })
      .addCase(REGISTER.pending, (state) => {
        state.formSubmitted = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(REGISTER.fulfilled, (state, action) => {
        const { success, payload } = action;
        state.message = success;
        state.collections.unshift(payload);
        state.isSuccess = true;
        state.formSubmitted = false;
      })
      .addCase(REGISTER.rejected, (state, action) => {
        state.message =
          action.payload || action.error?.message || "Something went wrong";
        state.formSubmitted = false;
      });
  },
});

export const { RESET, CUSTOMALERT, SetCOLLECTIONS } = reduxSlice.actions;

export default reduxSlice.reducer;
